import axios from 'axios';
import { ContactFormPayload, ContactSuccessResponse } from '../interface/contact.interface';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class ContactService {
  private axiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' },
  });

  /**
   * Submit a contact form
   */
  public async submitContact(payload: ContactFormPayload): Promise<ContactSuccessResponse> {
    const response = await this.axiosInstance.post<ContactSuccessResponse>('/contact', payload);
    return response.data;
  }
}

export const contactService = new ContactService();
